export const documentTemplateTypes = [
  "Appointment Letter", "Probation Confirmation", "Increment/Amendment",
  "Contract Renewal", "Termination Notice",
] as const;
export type DocumentTemplateType = (typeof documentTemplateTypes)[number];
export interface DocumentTemplate {
  id: string;
  type: DocumentTemplateType;
  html: string;
}
// Mock data shared between routes; changes reset on a full page refresh.
let templates: DocumentTemplate[] = [
  { id: "appointment", type: "Appointment Letter", html: "<h1>Appointment Letter</h1>\n<p>Dear {{employeeName}},</p>\n<p>We are pleased to confirm your appointment as {{designation}} from {{startDate}}.</p>" },
  { id: "probation", type: "Probation Confirmation", html: "<h1>Probation Confirmation</h1>\n<p>Dear {{employeeName}},</p>\n<p>Your probation has been successfully completed.</p>" },
  { id: "renewal", type: "Contract Renewal", html: "<h1>Contract Renewal</h1>\n<p>Dear {{employeeName}},</p>\n<p>Your contract is renewed until {{endDate}}.</p>" },
];
export const listDocumentTemplates = () => templates.map((item) => ({ ...item }));
export const findDocumentTemplate = (id: string) => templates.find((item) => item.id === id);
export const saveDocumentTemplate = (type: DocumentTemplateType, html: string, id?: string) => {
  if (id && !findDocumentTemplate(id)) throw new Error("Template not found.");
  if (!html.trim()) throw new Error("Paste the HTML code before saving.");
  if (templates.some((item) => item.type === type && item.id !== id)) {
    throw new Error("This template already exists. Edit the existing template instead.");
  }
  const template = { id: id ?? crypto.randomUUID(), type, html };
  templates = id ? templates.map((item) => item.id === id ? template : item) : [...templates, template];
};
export const deleteDocumentTemplate = (id: string) => {
  templates = templates.filter((item) => item.id !== id);
};
